export * from './parts-modal-grid.config';